import { render, staticRenderFns } from "./VButtonSettingsGear.vue?vue&type=template&id=7f10445c&"
import script from "./VButtonSettingsGear.vue?vue&type=script&lang=ts&"
export * from "./VButtonSettingsGear.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonSettingsGear.vue?vue&type=style&index=0&id=7f10445c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports